const TOKEN_MAX_TTL = 3600
const TOKEN_EXPIRATION_HEADER_NAME = 'x-token-expiration'
const TOKEN_EXPIRATION_KEY = 'tokenExpirationTimestamp'
const LAST_ACTIVITY_TIMESTAMP_KEY = 'lastActivityTimestamp'
const TOKEN_TTL_REFRESH_TRIGGER = TOKEN_MAX_TTL * 0.2
const INACTIVITY_TIME_LIMIT = TOKEN_MAX_TTL
const INACTIVITY_TIME_MODAL_TRIGGER = TOKEN_MAX_TTL * 0.95

export default {
  TOKEN_MAX_TTL,
  TOKEN_EXPIRATION_HEADER_NAME,
  TOKEN_EXPIRATION_KEY,
  TOKEN_TTL_REFRESH_TRIGGER,
  LAST_ACTIVITY_TIMESTAMP_KEY,
  INACTIVITY_TIME_LIMIT,
  INACTIVITY_TIME_MODAL_TRIGGER
}
